// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"X4-z","dimensionLabel":"Y4-z","styleChooserControlWrapper":"Z4-z","styleChooserControl":"_4-z","disabled":"a5-z","giftCard":"b5-z","styleChooserText":"c5-z"};